import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import LaboratoryLanding from '../Components/Laboratory/LaboratoryLanding';
import LaboratoryView from '../Components/Laboratory/LaboratoryView';

class LaboratoryContainer extends Component {
    constructor(props) {
        super(props);

        let ap = JSON.parse(localStorage.getItem('apikey'));

        this.state = {
            apikey: ap
        }

    }
    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">

                    <Switch>
                        <Route
                            exact
                            path="/laboratory"
                            render={
                                (props) => <LaboratoryLanding
                                    apikey={this.state.apikey}
                                    {...props}
                                />
                            }
                        />
                        <Route
                            exact
                            path="/laboratory/view"
                            render={
                                (props) => <LaboratoryView
                                    apikey={this.state.apikey}
                                    {...props}
                                />
                            }
                        />
                    </Switch>



                </div>
            </div>
        )
    }
}

export default withAuth(LaboratoryContainer);


// WEBPACK FOOTER //
// ./src/Containers/LaboratoryContainer.js